$(document).ready(function () {
	// Show full description
	const detailDescription = document.querySelector('.detail-description');

	if (detailDescription) {
		detailDescription.addEventListener('click', () => {
			const cover = detailDescription.querySelector('.detail-description__cover');

			detailDescription.style.cursor = 'default';
			detailDescription.style.setProperty('--clamp-rows', 'none');

			if (cover) {
				cover.style.display = 'none';
			}
		});
	}

	/* ------------------------------------------------- *\
		Magnific popup
		http://dimsemenov.com/plugins/magnific-popup/documentation.html
	\* ------------------------------------------------- */

	$('.lightbox-gallery').each(function () {
		$(this).magnificPopup({
			delegate: 'a.open',
			type: 'image',
			removalDelay: 300,
			mainClass: 'mfp-fade',
			autoFocusLast: false,
			fixedContentPos: false,
			fixedBgPos: false,
			tLoading: '',
			gallery: {
				enabled: true,
				arrowMarkup:
					'<button title="%title%" class="mfp-arrow mfp-arrow-%dir% test">\n' +
					'<svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" fill="none" viewBox="0 0 50 50">\n' +
					'  <path stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="m28.5 35-10-10 10-10"/>\n' +
					'</svg>\n' +
					'</button>'
			},
			image: {
				cursor: null,
				markup:
					'<div class="mfp-figure">' +
					'<div class="mfp-close"></div>' +
					'<div class="mfp-img"></div>' +
					'<div class="mfp-bottom-bar">' +
					'<div class="mfp-counter  p p3 text--c-white"></div>' +
					'</div>' +
					'</div>'
			},
			closeMarkup:
				'<button title="%title%" class="mfp-close">\n' +
				'<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">\n' +
				'  <path stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="m4 4 16 16m0-16L4 20"/>\n' +
				'</svg>\n' +
				'</button>',
			// Prevent scrolling on mobile device (https://github.com/dimsemenov/Magnific-Popup/issues/782):
			callbacks: {
				buildControls: function () {
					this.contentContainer.append(this.arrowLeft.add(this.arrowRight));
				}
			}
		});
	});

	/* --------------------------------------------- *\
		Video.js
	\* --------------------------------------------- */

	$('#video-container').on('contextmenu', function (event) {
		event.preventDefault();
	});

	// AR comparison for desktop
	function playerARCheck() {
		let windowWidth = $(window).width() - 128;
		let windowHeight = $(window).height() - 236;
		let ar = windowWidth / windowHeight;
		$('#video-container')
			.removeClass('hold-height hold-width')
			.addClass(ar > 16 / 9 ? 'hold-height' : 'hold-width');
	}

	if ($('body').data('page') === 'detail') {
		$(window).on('resize', function () {
			if ($(window).width() > 1039) {
				playerARCheck();
			}
		});
		playerARCheck();
	}

	// ------- PLUG-INS ------- //

	$('.video-js').each(function (videoIndex) {
		var videoId = $(this).attr('id');
		var player = videojs(videoId);

		player.on('ended', function () {
			if ($(videoId).data('play') !== 'True') {
				$.ajax({
					url: window.settings.urls.eventStore,
					type: 'GET',
					data: {
						event: 'video_ended',
						gallery_id: $(videoId).data('key')
					},
					success: function (response) {
						// console.log(response);
					},
					error: function (error) {
						console.error(error);
					}
				});
			}
		});

		videojs(videoId).ready(function () {
			// Hotkeys (https://www.npmjs.com/package/videojs-hotkeys)
			this.hotkeys({
				volumeStep: 0.1,
				seekStep: 5,
				enableModifiersForNumbers: false,
				enableVolumeScroll: false
			});
		});

		// Resolution Switcher (https://www.npmjs.com/package/videojs-resolution-switcher)
		videojs(videoId).videoJsResolutionSwitcher({
			default: $.browser.mobile ? 540 : 720,
			dynamicLabel: true
		});

		// "Join" splash after video playback is finished
		videojs(videoId).on('ended', function () {
			let video_ended = $('.video-player__ended');

			if (video_ended.length > 0) {
				video_ended.addClass('is-visible');
				$('.vjs-control-bar').css('display', 'none');
			}

			if (videojs($(videoId).get(0)).isFullscreen()) {
				videojs($(videoId).get(0)).exitFullscreen();
			}

			videojs(videoId, {
				autoplay: false,
				preload: 'auto'
			});

			let replay = $('.replay');
			if (replay) {
				$('.replay').click(function () {
					videojs($(videoId).get(0)).currentTime(0);
					videojs($(videoId).get(0)).play();
					video_ended.removeClass('is-visible');
					videojs($(videoId).get(0)).hotkeys({
						volumeStep: 0.1,
						seekStep: 5,
						enableModifiersForNumbers: false,
						enableVolumeScroll: false
					});
					setTimeout(function () {
						$('.vjs-control-bar').css('display', '');
					}, 100);
				});
			}
		});

		let video_js_unmute = $('.video-js__unmute');

		$('#video').on('click', function () {
			remove_btn_unmute();
		});

		video_js_unmute.on('click', function () {
			remove_btn_unmute();
		});

		function remove_btn_unmute() {
			if (video_js_unmute.length > 0) {
				videojs(videoId).muted(false);
				video_js_unmute.remove();
			}
		}
	});
});
